// lib/meilisearch.js
import { MeiliSearch } from 'meilisearch'

let clientInstance = null

export const getMeiliSearchClient = () => {
  if (!clientInstance) {
    clientInstance = new MeiliSearch({
      host: process.env.MEILISEARCH_HOST || 'http://localhost:7700',
      apiKey: process.env.MEILISEARCH_API_KEY || 'aSampleMasterKey',
    })
  }
  return clientInstance
}
export async function initializePropertySearch() {
  try {
    const client = getMeiliSearchClient()
    const index = client.index('properties-test3')

    await index.updateSettings({
      pagination: {
        maxTotalHits: 10000,
      }
    })
    
    // Set filterable attributes
    await index.updateFilterableAttributes([
      'agency.id',
      'propertyDescription.category',
      'propertyDescription.listedIn',
      'propertyDescription.propertyStatus',
      'propertyDescription.price',
      'wilaya',
      'city',
      'detailSection.surface',
      'detailSection.rooms',
      'detailSection.bedrooms',
      'detailSection.bathrooms',
      'amenitiesSection.generator',
      'amenitiesSection.waterTank',
      'amenitiesSection.gasConnection',
      'amenitiesSection.garage',
      'amenitiesSection.balcony',
      'amenitiesSection.elevator',
      'amenitiesSection.garden',
      'amenitiesSection.terrace',
      'amenitiesSection.nearbyMosque',
      'amenitiesSection.sharedParking',
      'amenitiesSection.airConditioning',
      'amenitiesSection.heater',
      'amenitiesSection.frontYard',
      'amenitiesSection.gym',
      'amenitiesSection.laundry',
      'amenitiesSection.privateSpace',
      'amenitiesSection.refrigerator',
      'amenitiesSection.sauna',
      'amenitiesSection.seaView',
      'amenitiesSection.waterTank',
      'amenitiesSection.wifi',
    ])

    // Set sortable attributes
    await index.updateSortableAttributes([
      'propertyDescription.price',
      'detailSection.surface',
      'detailSection.rooms',
      'createdAt',
      'refreshedAt',
    ])

    // Set searchable attributes (optional, if you want to prioritize certain fields)
    await index.updateSearchableAttributes([
      'propertyDescription.title',
      'propertyDescription.description',
      'locationSection.address',
      'locationSection.neighborhood',
      'city',
      'wilaya',
    ])

    console.log('Meilisearch property index configured successfully')
    return true
  } catch (error) {
    console.error('Error initializing Meilisearch:', error)
  }
}
